import preset from "@/@core/preset/preset";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import en from "vuetify/es5/locale/en";
import SortIcon from "@/components/icons/SortIcon";

Vue.use(Vuetify);
// Suppresses the vuetify warnings
// https://github.com/vuetifyjs/vuetify/pull/10909/files
Vuetify.config.silent = process.env.NODE_ENV === "production";

export default new Vuetify({
  preset,
  lang: {
    locales: { en },
    current: process.env.VUE_APP_I18N_LOCALE || "en",
  },
  /**
   * Surprisingly ;) , adding custom icons here doesn't work, unless an icon name
   * is already used by vuetify itself (for example "sort")
   */
  icons: {
    iconfont: "mdiSvg",
    values: {
      sort: {
        component: SortIcon,
      },
    },
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },
});
